<template>
  <tr :class="{ strikeout: eliminado }">
    <td>{{ item.linea }}</td>
    <td>{{ item.articulo.id }}</td>
    <td>
      <div v-if="!item.esKit">{{ item.articulo.descripcion }}</div>
      <div v-else>
        <a
          href="#"
          class="button-link"
          @click.prevent="mostrarDetalleKitHandle"
        >
          {{ item.articulo.descripcion }}
        </a>
        &nbsp;
        <div v-if="item.esKit" class="tag is-info">
          Kit: {{ item.articulo.id }}
        </div>
      </div>
    </td>
    <td class="has-text-centered">{{ unidadMedida }}</td>
    <td class="has-text-right">{{ item.stock }}</td>
    <td class="has-text-right">{{ cantidadSolicitada }}</td>
    <td class="has-text-right">{{ cantidadFacturada }}</td>
    <td class="has-text-right">{{ cantidadPickeada }}</td>
    <td class="has-text-right">{{ pendiente }}</td>
    <td>
      <b-numberinput
        v-if="puedeModificarCantidad(item)"
        ref="stepper"
        v-model="cantidadLocal"
        size="is-small"
        :step="multiplo"
        :min="0"
        :max="cantidadSolicitada"
        controls-rounded
        rounded
        @focus="inputCantidadFocusHandle"
        @blur="inputCantidadBlurHandle"
        @input="changeCantidadHandle"
        @keyup.enter.native="teclaEnterHandle"
      />
      <p v-else class="has-text-centered">
        {{ item.cantidadEntregada }}
      </p>
    </td>
    <td v-if="!esUsuarioMonitor">
      <div class="has-text-centered">
        <b-field v-if="debeConfirmarEntregaParcial" expanded>
          <b-checkbox
            class="mt-1 mr-0 ml-2"
            type="is-danger"
            @input="confirmarParcialHandle"
          ></b-checkbox>
        </b-field>
        <b-icon v-else :icon="iconoEntrega" :type="colorEntrega"></b-icon>
      </div>
    </td>
    <b-modal
      :active="mostrarDetalleKit"
      has-modal-card
      aria-role="dialog"
      aria-label="Detalle kit"
      aria-modal
      :can-cancel="true"
    >
      <detalle-kit-modal :item="item" @close="closeHandle" />
    </b-modal>
  </tr>
</template>

<script>
import DetalleKitModal from '@/components/cierre/DetalleKitModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CierreDetalleItem',
  components: {
    DetalleKitModal
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    esItemActual: {
      type: Boolean,
      default: false
    },
    esPedidoCerrado: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeout: null,
      disabled: false,
      hasFocus: false,
      mostrarDetalleKit: false,
      cantidadLocal: 0
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    cantidadEntregadaInput() {
      return this.item.cantidadEntregada * this.multiplo
    },
    cantidadFacturada() {
      return this.item.cantidadFacturada * this.multiplo
    },
    cantidadPickeada() {
      return this.item.cantidadPickeada * this.multiplo
    },
    cantidadSolicitada() {
      return this.item.cantidadSolicitada * this.multiplo
    },
    colorEntrega() {
      return this.esEntregaCompleta ? 'is-success' : 'is-danger'
    },
    debeConfirmarEntregaParcial() {
      if (this.item.esKit) {
        return (
          !this.item.confirmaEntrega &&
          this.item.cantidadEntregada < this.item.cantidadSolicitada
        )
      } else {
        return (
          !this.item.confirmaEntrega &&
          this.item.cantidadEntregada < this.item.cantidadSolicitada &&
          this.item.stock >= this.item.cantidadSolicitada
        )
      }
    },
    eliminado() {
      return [3, 4].includes(this.item.tipoModificacion.id)
    },
    esEntregaCompleta() {
      return this.item.cantidadEntregada === this.item.cantidadSolicitada
    },
    hayMedidaInventario() {
      return (
        this.item.unidadMedida !==
        (this.item.unidadMedidaInventario ?? this.item.unidadMedida)
      )
    },
    multiplo() {
      if (this.item.multiplo && this.item.multiplo > 0)
        return this.item.multiplo
      return 1
    },
    iconoEntrega() {
      return this.esEntregaCompleta ? 'check' : 'exclamation'
    },
    pendiente() {
      return (
        (this.item.cantidadSolicitada - this.item.cantidadEntregada) *
        this.multiplo
      )
    },
    unidadMedida() {
      return this.hayMedidaInventario
        ? this.item.unidadMedidaInventario
        : this.item.unidadMedida
    },
    esUsuarioMonitor() {
      // Si usuario tiene rol Monitor, no se muestran acciones
      return this.bodega.roles.some((rol) => rol.id === 6)
    }
  },
  watch: {
    cantidadEntregadaInput: {
      immediate: true,
      handler(val) {
        if (this.cantidadLocal !== val) {
          this.cantidadLocal = val
        }
      }
    },
    esItemActual(seleccionado) {
      // Si es la línea seleccionada, se activa foco
      if (seleccionado && this.$refs.stepper) {
        this.$refs.stepper.focus()
      }
    }
  },
  methods: {
    inputCantidadFocusHandle(event) {
      event.target.select()
      this.hasFocus = true
    },
    inputCantidadBlurHandle() {
      this.hasFocus = false
    },
    changeCantidadHandle(value) {
      if (this.timeout) clearTimeout(this.timeout)
      if (this.hasFocus) {
        const self = this
        this.timeout = setTimeout(function () {
          self.processCantidadHandle(value)
        }, 300)
      } else {
        this.processCantidadHandle(value)
      }
    },
    processCantidadHandle(value) {
      if (this.disabled) return
      this.disabled = true
      if (this.hasFocus) {
        // Si valor es mayor a cantidad solicitada, se modifica a este valor
        if (value > this.cantidadSolicitada) value = this.cantidadSolicitada
        // Si valor es menor a cero, se modifica a este valor
        if (value < 0) value = 0
        // Si valor no está en relación al múltiplo, se redondea...
        const resto = value % this.multiplo
        if (resto !== 0) {
          value =
            resto <= this.multiplo / 2
              ? value - resto
              : value + this.multiplo - resto
        }
        this.cantidadLocal = value
      }
      this.$store
        .dispatch('despacho/setCantidadDespachada', {
          id: this.item.id,
          cantidadEntregada: value / this.multiplo,
          linea: this.item.linea,
          pedidoId: this.item.pedidoId
        })
        .then((_) => (this.disabled = false))
    },
    teclaEnterHandle() {
      this.$emit('move-next', this.item.id)
    },
    async confirmarParcialHandle(value) {
      if (value) {
        await this.$store.dispatch('despacho/confirmarEntregaParcial', {
          id: this.item.id,
          linea: this.item.linea,
          pedidoId: this.item.pedidoId
        })
      }
    },
    mostrarDetalleKitHandle() {
      this.mostrarDetalleKit = true
    },
    closeHandle() {
      this.mostrarDetalleKit = false
    },
    puedeModificarCantidad(item) {
      return (
        !this.eliminado &&
        !item.fueEntregado &&
        !this.esPedidoCerrado &&
        !this.esUsuarioMonitor
      )
    }
  }
}
</script>

<style lang="scss" scoped>
$checkbox-background-color: white;

td {
  position: relative;
}

tr.strikeout td:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 1px solid #363636;
  width: 100%;
}

tr.strikeout td:after {
  content: '\00B7';
  font-size: 1px;
}

.checkbox-item {
  background-color: white;
}

.button-link {
  border: none;
  color: inherit;
  padding: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #3e8ed0;
  }
}
</style>
